<template>
  <div class="card-image">
    <img 
      :src="imageUrl"
      :alt="altText" 
      class="event-image"
    />
  </div>
</template>

<script setup>
import { defineProps, computed  } from 'vue';
import config from "@/config"; 

const props = defineProps({
  image: { 
    type: String,
    required: true
  },
  altText: {  
    type: String,
    default: ''
  }
});

const imageUrl = computed(() => {
  return `${config.backendUrl}/${props.image}`;
});
</script>

<style scoped>
.card-image {
  width: 100%;
  height: 224px;
  overflow: hidden;
}

.event-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (max-width: 992px) {
  .card-image { height: 224px; }
}

@media (max-width: 768px) {
  .card-image { height: 200px; }
}

@media (max-width: 480px) {
  .card-image { height: 180px; }
}
</style>